import styled from '@xstyled/styled-components';
import StampImage from './stamp.svg';

export const EnvelopeBackground = styled.img`
  position: absolute;
  z-index: 2;
  bottom: -150px;
  caret-color: transparent;
  left: -123px;
  @media (max-width: lg) {
    width: 645px;
    height: 220px;
    bottom: -70px;
  }
  @media (max-width: md) {
    bottom: -50px;
    left: -110px;
    width: 568px;
    height: 170px;
  }
  @media (max-width: sm) {
    display: none;
  }
`;

export const Stamp = styled(StampImage)`
  position: absolute;
  z-index: 1;
  bottom: 10px;
  right: 60px;
  width: 96px;
  height: 96px;
  object-fit: contain;
`;

export const Header = styled.divBox`
  background-color: ${p => p.theme.colors.accentDark};
  border-radius: 20px 20px 0 0;
  display: flex;
  align-items: center;
  padding: 10px 20px;
  color: #fff;

  b {
    margin-left: 7px;
  }
`;

export const Body = styled.divBox`
  margin-top: 25px;
  margin-bottom: 25px;
  font-family: Raleway;
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 150%;
  color: black;
  min-height: 125px;
  font-weight: 100;

  & strong {
    font-weight: 700;
    font-size: 17px;
  }
  p {
    color: black !important;
  }
`;
